import React from 'react';
const stats = [{
  value: '15+',
  label: 'YEARS EXPERIENCE'
}, {
  value: '350+',
  label: 'BRANDS SUPPORTED'
}, {
  value: '5',
  label: 'APPS IN DEVELOPMENT'
}];
export function StatsBar() {
  return <section className="py-16 bg-surface border-y border-border" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-4xl mx-auto" data-id="element-82">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-83">
              <div className="text-4xl md:text-5xl font-serif font-bold text-primary mb-2" data-id="element-84">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-muted font-sans font-semibold uppercase tracking-wider" data-id="element-85">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}